module.exports = __webpack_public_path__ + "img/guinea.f33b85e3.svg";